import { BaseSelect } from '@app/components';
import { stepApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IStep } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IStep>();

export const StepSelect = ({ label = 'Etapes', ...props }: ResourceSelectParentProps<IStep>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={stepApi.useReadManyStepQuery}
      {...props} />
  );
};
